import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap'

interface LoadingProps {
  pageCount?: number
  itemsPerPage?: number
}

const Loading: React.FC<LoadingProps> = (props) => {
  const { pageCount = 6, itemsPerPage = 15 } = props
  return (
    <>
      <div className='mb-auto placeholder-glow w-100'>
        <ul>
          {Array.from({ length: itemsPerPage }, (_, index) => (
            <li key={index}>
              <span className='placeholder w-50 mb-2' data-testid='placeholder' />
            </li>
          ))}
        </ul>
      </div>
      <div className='w-100 d-flex justify-content-center flex-column align-items-center'>
        <div className='text-center mb-3'>
          Page __ of __
        </div>
        <Pagination size='sm' className='justify-content-center'>
          <PaginationItem disabled>
            <PaginationLink href='#'>
              <FontAwesomeIcon icon={faAngleDoubleLeft} />
            </PaginationLink>
          </PaginationItem>
          <PaginationItem disabled>
            <PaginationLink href='#'>
              <FontAwesomeIcon icon={faAngleDoubleLeft} />
            </PaginationLink>
          </PaginationItem>
          {Array.from({ length: pageCount }, (_, index) => (
            <PaginationItem key={index} disabled>
              <PaginationLink href='#'>
                0
              </PaginationLink>
            </PaginationItem>
          ))}
          <PaginationItem disabled>
            <PaginationLink href='#'>
              <FontAwesomeIcon icon={faAngleDoubleLeft} />
            </PaginationLink>
          </PaginationItem>
          <PaginationItem disabled>
            <PaginationLink href='#'>
              <FontAwesomeIcon icon={faAngleDoubleLeft} />
            </PaginationLink>
          </PaginationItem>
        </Pagination>
      </div>
    </>
  )
}

export default Loading
